import React, { Component } from "react";
import { PropTypes } from "prop-types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ReactTooltip from "react-tooltip";

import ReloadByTransference from "./balance-sections/ReloadByTransference";
import FastTransference from "./balance-sections/FastTransference";
import GenerateAlert from "./balance-sections/GenerateAlert";
import WithdrawFunds from "./balance-sections/WithdrawFunds";
import { translate as t } from "../../../infrastructure/translate/localization";

import reloadAccount from "../../../assets/img/bank-transfer.svg";
import reloadFast from "../../../assets/img/fast-funding.svg";
import withdrawFunds from "../../../assets/img/withdraw-funds.svg";
import generateAlert from "../../../assets/img/generate-warning.svg";

import "./balance-section.scss";

export default class BalanceSection extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showSection: null,
    };
  }

  render() {
    const {
      loaded,
      balance,
      autoClose,
      prediction,
      blockedBalance,
      accountId,
      alertThreshold,
      alertThresholdEmails,
    } = this.props;

    const { showSection } = this.state;

    return (
      <div className="sub-section">
        <div className="balance-section">
          <div className="balance-content">
            <div className="balance-info">
              <div className="balance">
                <div className="balance-col">
                  <div className="balance-total">
                    <div className="icon">
                      <FontAwesomeIcon icon="coins" />
                    </div>
                    <div className="balance-total-amount">
                      <span>{t("my-account-section.balance-total")}</span>
                      <span className="amount">{balance}</span>
                    </div>
                  </div>
                </div>

                {loaded && blockedBalance && blockedBalance !== "0€" && (
                  <div className="balance-col">
                    <span>
                      {t("my-account-section.balance")}
                      <span className="balance-tooltip">
                        <FontAwesomeIcon
                          data-tip={t(
                            "my-account-section.authorized-transactions-tooltip"
                          )}
                          icon="info-circle"
                        />
                        <ReactTooltip
                          className="tooltipMessage"
                          place="bottom"
                          effect="solid"
                          type="light"
                        />
                      </span>
                    </span>
                    <span className="amount">{blockedBalance}</span>
                  </div>
                )}
              </div>
              {loaded && prediction && (
                <span className="predictive">
                  <FontAwesomeIcon icon="exclamation-triangle" />
                  {t("my-account-section.predictive-info", {
                    amount: prediction,
                    date: autoClose,
                  })}
                </span>
              )}
            </div>

            <div className="balance-actions">
              <div className="action-container">
                <div
                  role="presentation"
                  className="action"
                  onClick={() =>
                    loaded && this.setState({ showSection: "reloadAccount" })
                  }
                >
                  <img src={reloadAccount} alt="reload transference" />
                  <span>{t("my-account-section.transfert-recharge")}</span>
                </div>
                <div
                  role="presentation"
                  className="action"
                  onClick={() =>
                    loaded && this.setState({ showSection: "reloadFast" })
                  }
                >
                  <img src={reloadFast} alt="reload fast" />
                  <span>{t("my-account-section.fast-charge")}</span>
                </div>
              </div>
              <div className="action-container">
                <div
                  role="presentation"
                  className="action"
                  onClick={() =>
                    loaded && this.setState({ showSection: "generateAlert" })
                  }
                >
                  <img src={generateAlert} alt="generate alert" />
                  <span>{t("my-account-section.generate-warning")}</span>
                </div>

                <div
                  role="presentation"
                  className="action"
                  onClick={() =>
                    loaded && this.setState({ showSection: "withdrawFunds" })
                  }
                >
                  <img src={withdrawFunds} alt="withdraw funds" />
                  <span>{t("my-account-section.withdrawn-funds")}</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        {loaded && showSection === "reloadAccount" && (
          <ReloadByTransference accountId={accountId} />
        )}
        {loaded && showSection === "reloadFast" && <FastTransference />}
        {loaded && showSection === "generateAlert" && (
          <GenerateAlert
            alertThreshold={alertThreshold}
            alertThresholdEmails={alertThresholdEmails}
          />
        )}
        {loaded && showSection === "withdrawFunds" && <WithdrawFunds />}
      </div>
    );
  }
}

BalanceSection.defaultProps = {
  loaded: false,
  balance: "0€",
  blockedBalance: "0€",
  autoClose: "",
  prediction: "",
  accountId: "",
  alertThreshold: null,
  alertThresholdEmails: [],
};

BalanceSection.propTypes = {
  loaded: PropTypes.bool,
  balance: PropTypes.string,
  blockedBalance: PropTypes.string,
  autoClose: PropTypes.string,
  prediction: PropTypes.string,
  accountId: PropTypes.string,
  alertThreshold: PropTypes.number,
  alertThresholdEmails: PropTypes.array,
};
